/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeId = {
    type: 'number',
    format: 'int32',
};